import { FlowerCartProduct, FlowerProduct as IFlowerProduct } from '../../../types'

interface CalculateOrderParam {
  code: string
  price: number
  zip: string
}

const isFlowerCartProduct = (
  product: IFlowerProduct | FlowerCartProduct,
): product is FlowerCartProduct => {
  return !!(product as FlowerCartProduct).price_in_cents
}

const orderTotal = (products: Array<IFlowerProduct | FlowerCartProduct>): number => {
  return products.reduce((sum, product) => {
    if (isFlowerCartProduct(product)) {
      sum += (product.price_in_cents / 100.0) * product.quantity
    } else {
      sum += product.price
    }

    return sum
  }, 0)
}

const toGaItem = (product: IFlowerProduct): Gtag.Item => ({
  item_id: product.code,
  item_name: product.name,
  price: product.price,
  quantity: 1,
})
const cartProductToGaItem = (product: FlowerCartProduct): Gtag.Item => ({
  item_id: product.external_id,
  item_name: product.name,
  price: product.price_in_cents / 100.0,
  quantity: product.quantity,
})

const FlowerProduct = {
  orderTotal,
  productsQuantity: (products: FlowerCartProduct[]): number =>
    products.reduce((quantity, product) => (quantity += product.quantity), 0),
  toCalculateOrderParams: (products: FlowerCartProduct[], zip: string): CalculateOrderParam[] =>
    products.flatMap((p) =>
      Array<CalculateOrderParam>(p.quantity).fill({
        price: p.price_in_cents / 100,
        code: p.external_id,
        zip,
      }),
    ),
  toGaItem,
  cartProductToGaItem,
}

export default FlowerProduct
